if ('TCMS' in window && Array.isArray(window.TCMS.widgets)) {
    const widgets = window.TCMS.widgets;

    for (const widgetName of widgets) {
        import(`./${widgetName}/import`).catch((err) => {
            console.log(widgetName + ' loading error');
            console.error(err);
        });
    }
}
